import {
	FETCH_EVENTS,
	UPDATE_EVENT,
	SHOW_EVENT_DETAILS,
	HIDE_EVENTS_DETAILS,
	RECEIVED_EVENTS
} from '../actions/events.js'

const eventsReducer = (state = {fetchedEvents: false, events: []}, action) => {
	switch (action.type) {
		case FETCH_EVENTS:
			return {
				...state,
			  fetchedEvents: false
			}
		case SHOW_EVENT_DETAILS:
			return {
				...state,
				selectedEvent: action.event,
				fetchedEvents: true
			}
		case HIDE_EVENTS_DETAILS:
			return {
				...state,
				selectedEvent: undefined,
				fetchedEvents: true
			}
		case RECEIVED_EVENTS:

			let newSelectedEvent = undefined
			if (state.selectedEvent) {
				newSelectedEvent = action.events.find((event) => {return event._id === state.selectedEvent._id})
			}

			return {
				...state,
				fetchedEvents: true,
				events: action.events,
				selectedEvent: newSelectedEvent
			}
		case UPDATE_EVENT:
			return {
				...state,
				events: state.events.map(e => (e._id === action.event._id) ? action.event : e),
				selectedEvent: action.event
			}
		default:
			return state
	}
}

export default eventsReducer;



// WEBPACK FOOTER //
// ./src/reducers/events.js